// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__xBQ2k","buttons":"SendReceipts_buttons__1bG1d","email":"SendReceipts_email__3_ZCj","bookApptTitle":"SendReceipts_bookApptTitle__1ZNGI"};